import React from 'react'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'

export const HardLoadingCover = () => {
  return (
    <div className="flex justify-center items-center left-0 top-0 fixed z-60 w-full h-full bg-white">
          <div className="relative h-auto animate-pulse">
              <Image height={60} width={70} src={s3Static + "logo.png"} alt="StringsSg Logo"/>
          </div>
    </div>
  )
}
